import { WithEnterpriseId, WithServiceId } from '@mews-commander/types';
import { RateType } from '@mews-commander/data-access';
import { useGroupedRatesOptions } from '@mews-commander/legacy-entities/src/queries/rates';
import { useRateGroupsOptions, useResourceCategoryOptions } from '../queries';

export const useSellLimitOptions = ({ enterpriseId, serviceId }: WithEnterpriseId & WithServiceId) => {
    const groupedRateOptionsResult = useGroupedRatesOptions({
        serviceId,
        enterpriseId,
        filterRate: (rate) => rate.type !== RateType.AvailabilityBlock,
    });
    const rateGroupOptionsResult = useRateGroupsOptions({ serviceId, enterpriseId });
    const resourceCategoryOptionsResult = useResourceCategoryOptions({ serviceId, enterpriseId });

    const isFetching =
        groupedRateOptionsResult.isFetching ||
        rateGroupOptionsResult.isFetching ||
        resourceCategoryOptionsResult.isFetching;

    return {
        isFetching,
        groupedRateOptions: groupedRateOptionsResult.data ?? [],
        rateGroupOptions: rateGroupOptionsResult.data ?? [],
        resourceCategoryOptions: resourceCategoryOptionsResult.data ?? [],
    };
};
